<template>
  <div class="transaction">
    <div class="row">
      <div
        class="col-md-6 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ stats.footerText }}
          </div>
        </stats-card>
      </div>
    </div>

    <div class="col-12 d-flex align-items-center">
      <div class="form-row align-items-center">
        <div class="col-auto">
          <label for="inlineFormInput">Status</label>
          <select class="form-control" v-model="status">
            <option value="">Select Status</option>
            <option value="successful">Successful</option>
            <option value="failed">Failed</option>
            <option value="pending">Pending</option>
            <option value="wasRequeried">Requeried Transactions</option>
          </select>
        </div>

        <div class="col-auto">
          <label for="inlineFormInput">Limit</label>
          <select class="form-control" v-model="limit">
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="300">300</option>
            <option value="500">500</option>
          </select>
        </div>

        <div
          class="col-auto"
          v-if="
            auth.user.userType === 'super-admin' ||
            auth.user.userType === 'financial-admin'
          "
        >
          <label for="inlineFormInput">Filter By:</label>
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="terminalId">Terminal Id</option>
            <option value="stan">Stan</option>
            <option value="reference">Reference</option>
            <option value="provider">Provider</option>
          </select>
        </div>

        <div class="col-auto mt-4" v-if="selectedValue">
          <label for="inlineFormInput">Enter Value</label>
          <div class="input-group">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto mt-2">
          <label>Start Date</label>
          <div class="input-group mb-2">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Start Date"
              v-model="startDate"
            />
          </div>
        </div>

        <div class="col-auto mt-2">
          <label>End Date</label>
          <div class="input-group mb-2">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="End Date"
              v-model="endDate"
            />
          </div>
        </div>

        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('filter')"
          >
            Filter
          </button>
        </div>

        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('download')"
          >
            Download
          </button>
        </div>

        <div class="mb-2 mt-4" style="display: flex; gap: 12px">
          <button class="btn btn-info" @click="refresh('refresh')">
            Refresh
          </button>
          <button class="btn btn-info" @click="sendbatchRequery()">
            Send Batch Requery
          </button>
        </div>
      </div>
    </div>

    <div class="spinner-grow" role="status" v-if="loading === true"></div>

    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive table-container">
          <table class="table">
            <thead class="tms-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Transaction Type</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <th scope="col" class="text-center">Wallet ID</th>
                <th scope="col" class="text-center">Card Number</th>
                <th scope="col" class="text-center">Stan</th>
                <th scope="col" class="text-center">Merchant Id</th>
                <th scope="col" class="text-center">Amount</th>
                <th scope="col" class="text-center">Reference</th>
                <th scope="col" class="text-center">Processor</th>
                <th scope="col" class="text-center">Response Code</th>
                <th scope="col" class="text-center">Message</th>
                <th scope="col" class="text-center">Date</th>
                <th scope="col" class="text-center">Credit Status</th>
                <th scope="col" class="text-center">Wallet Credit</th>
                <th scope="col" class="text-center">Was Requeried</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="loading === true">
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-else-if="transactions.length === 0 && loading === false">
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Withdrawals Transactions Found</span>
                  </div>
                </td>
              </tr>

              <template v-else>
                <tr
                  v-for="(transaction, index) in transactions"
                  :key="transaction._id"
                  class="trans-detail"
                >
                  <!-- <th class="text-center">
                    <input
                      type="checkbox"
                      name=""
                      :value="transaction._id"
                      v-model="unsentList"
                    />
                  </th> -->
                  <th class="text-center">
                    {{ limit * (page - 1) + (index + 1) }}
                  </th>
                  <td class="text-center">
                    {{ transaction.product.toUpperCase() }}
                  </td>
                  <td class="text-center">{{ transaction.terminalId }}</td>
                  <td class="text-center">{{ transaction.walletId }}</td>
                  <td class="text-center">{{ transaction.maskedPan }}</td>
                  <td class="text-center">{{ transaction.stan }}</td>
                  <td class="text-center">
                    {{
                      transaction.terminalInformation
                        ? transaction.terminalInformation.merchantId
                        : ""
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      `₦${format.format(transaction.amount.toFixed(2) / 100)}`
                    }}
                  </td>
                  <td class="text-center ref">
                    {{ transaction.reference || "Null" }}
                  </td>
                  <td class="text-center">
                    {{ transaction.provider || "N/A" }}
                  </td>

                  <td class="text-center">
                    <button :class="getResponseCodeClass(transaction)">
                      {{
                        transaction.response
                          ? transaction.response.responseCode
                          : ""
                      }}
                    </button>
                  </td>
                  <td class="text-center">
                    {{
                      transaction.response
                        ? transaction.response.description
                        : ""
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      moment(transaction.createdAt)
                        .utcOffset("+00:00")
                        .format("YYYY-MM-DD hh:mm A")
                    }}
                  </td>
                  <td class="text-center">
                    {{ transaction.walletCredit ? "credited" : "no credit" }}
                  </td>
                  <td class="text-center">
                    <button
                      v-if="
                        transaction.response &&
                        transaction.response.responseCode === '00' &&
                        !transaction.walletCredit
                      "
                      class="tab-btn btn-credit"
                      @click="creditAgent(transaction._id)"
                    >
                      Credit Agent
                    </button>

                    <div v-else>
                      <p>--</p>
                    </div>
                  </td>
                  <td class="text-center">
                    {{ transaction.wasRequeried }}
                  </td>
                  <td>
                    <button
                      class="btn btn-info"
                      @click="updateModal(true, transaction)"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>

    <!-- <div class="mt-2 paginate-btns">
      <div class="p-2">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('previous')"
        >
          Prev
        </button>
      </div>
      <div>Page {{ currentPage }} of {{ totalPages }}</div>
      <div class="p-2" v-if="hasNextPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('next')"
        >
          Next
        </button>
      </div>
    </div>
    <div class="mt-2 d-flex justify-content-end align-items-center">
      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div> -->
    <TransactionDetailsModal
      :show-trans-detail="showTransDetail"
      :close-modal="closeModal"
      :modal-trans-detail="modalTransDetail"
    />
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";
import { mapActions, mapState } from "vuex";
import { StatsCard, ChartCard } from "@/components/index";
import TransactionDetailsModal from "./Modals/TransactionDetailsModal.vue";
export default {
  components: {
    StatsCard,
    TransactionDetailsModal,
  },

  data() {
    return {
      // pagination
      currentPage: 1,
      itemsPerPage: 30,

      //modal
      showTransDetail: false,
      modalTransDetail: {},

      transaction: {
        response: {
          responseCode: "00",
        },
      },
      statsCards: [
        {
          type: "info",
          icon: "ti-save",
          title: "Total Transactions",
          value: "₦0",
          footerText: "All Trasactions",
          footerIcon: "ti-reload",
        },
        {
          type: "primary",
          icon: "ti-wallet",
          title: "Successful",
          value: "₦0",
          footerText: "Successful Transactions",
          footerIcon: "ti-reload",
        },
        {
          type: "warning",
          icon: "ti-server",
          title: "Pending Transactions",
          value: "₦0",
          footerText: "Pending Trasactions",
          footerIcon: "ti-reload",
        },
        {
          type: "danger",
          icon: "ti-pulse",
          title: "Failed",
          value: "₦0",
          footerText: "Failed Transactions",
          footerIcon: "ti-reload",
        },
      ],
      error: false,
      transactions: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      status: "",
      searchValues: {
        terminalId: "",
        walletId: "",
        reference: "",
        stan: "",
      },
      totalDocs: 0,
      pageNumbers: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      allChecked: false,
      selectedValue: "",
      product: "withdrawal",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    updateModal(showTD, tran) {
      this.showTransDetail = showTD;
      this.modalTransDetail = tran;
    },

    closeModal() {
      this.showTransDetail = false;
    },

    getResponseCodeClass(transaction) {
      return {
        "text-center": true,
        "code-btn": true,
        successful:
          transaction.response && transaction.response.responseCode === "00",
        other:
          transaction.response && transaction.response.responseCode !== "00",
      };
    },
    async creditAgent(id) {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/transaction/credit-agent`,
          { id },
        );
        const { message } = res.data;
        this.setNotification({
          type: "success",
          message,
        });
        this.refresh("");
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          // console.log(error);
          this.setNotification({
            type: "danger",
            message: "Unable to Send Notification",
          });
        }
      }
      this.loading = false;
    },
    async refresh(mode) {
      try {
        this.loading = true;
        if (mode === "filter" || mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
        }
        if (mode === "refresh") {
          this.startDate = moment().format("YYYY-MM-DD");
          this.endDate = moment().format("YYYY-MM-DD");
        }
        let payload = {
          page: this.page,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate,
          product: this.product,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/transactions/details`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.transactions);
          fileDownload(csvTran, "transactions.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.transactions;
          this.transactions = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
          const { failed, successful, total, pending } = res.data.summary;
          this.statsCards[0].value = `₦${this.format.format(
            total.toFixed(2) / 100,
          )}`;
          this.statsCards[1].value = `₦${this.format.format(
            successful.toFixed(2) / 100,
          )}`;
          this.statsCards[2].value = `₦${this.format.format(
            pending.toFixed(2) / 100,
          )}`;
          this.statsCards[3].value = `₦${this.format.format(
            failed.toFixed(2) / 100,
          )}`;
        }
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Transactions",
          });
        }
      }
      this.loading = false;
    },
    async sendbatchRequery() {
      this.$confirm("Send Batch Requery?").then(async () => {
        this.loading = true;
        console.log(this.unsentList);
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/transaction/tms/kimono-batch-requery`,
            { ids: this.unsentList },
          );
          const { message } = res.data;
          this.setNotification({
            type: "success",
            message,
          });
          this.refresh("");
        } catch (error) {
          if (error.response && error.response.data) {
            const { message } = error.response.data;
            this.setNotification({ type: "danger", message });
          } else {
            console.log(error);
            this.setNotification({
              type: "danger",
              message: "Unable to Send Requery",
            });
          }
        }
        this.loading = false;
      });
    },
    checkAll() {
      if (this.allChecked === false) {
        this.unsentList = this.transactions.map((el) => el._id);
      } else {
        this.unsentList = [];
      }
      this.allChecked = !this.allChecked;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        reference: "",
        stan: "",
      };
    },
  },
  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh("filter");
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/transactions/details`,
        {
          page: this.page,
          startDate: this.startDate,
          endDate: this.endDate,
          product: this.product,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.transactions;
      this.transactions = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
      const { failed, successful, total, pending } = res.data.summary;
      this.statsCards[0].value = `₦${this.format.format(
        total.toFixed(2) / 100,
      )}`;
      this.statsCards[1].value = `₦${this.format.format(
        successful.toFixed(2) / 100,
      )}`;
      this.statsCards[2].value = `₦${this.format.format(
        pending.toFixed(2) / 100,
      )}`;
      this.statsCards[3].value = `₦${this.format.format(
        failed.toFixed(2) / 100,
      )}`;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Transactions",
        });
      }
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}

table td,
table th {
  white-space: nowrap;
}

.table-container {
  overflow-x: auto;
}

th {
  font-size: 12px !important;
}

.spinner-grow {
  position: fixed;
}

tbody {
  background: #fff !important;
}

.tms-dark {
  background-color: #333f48;
  color: #fff;
}

.ref {
  font-size: 8px;
}

button {
  padding: 0.2rem 10px !important;
}

.code-btn {
  padding: 10px 15px !important;
  border: none;
  border-radius: 5px;
}

.btn-credit {
  background-color: rgb(11, 155, 11);
  border: 1px solid rgb(11, 155, 11);
}

.successful {
  background-color: rgb(11, 155, 11);
  color: #fff;
  font-weight: bolder;
}

.other {
  background-color: rgb(217, 16, 16);
  font-weight: bolder;
}

.paginate-btns {
  display: flex;
  grid-gap: 40px;
}
</style>
